module.exports = __webpack_public_path__ + "static/img/pic17.8558800.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic17.png
// module id = R1ve
// module chunks = 0